import { render, staticRenderFns } from "./TextbooksIndex.vue?vue&type=template&id=01be78c6&"
import script from "./TextbooksIndex.vue?vue&type=script&lang=ts&"
export * from "./TextbooksIndex.vue?vue&type=script&lang=ts&"
import style0 from "./TextbooksIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
